module.exports = __webpack_public_path__ + "static/media/radiation_safety_plan_training_matrix.ae8058f1.svg";